// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
 
.color-accent,
.color-accent-hover:hover,
.color-accent-hover:focus,
:root .has-accent-color,
.has-drop-cap:not(:focus):first-letter,
.wp-block-button.is-style-outline,
a {
  color: #000000;
}


.roboto {
    font-family: "Roboto", sans-serif;
}


.roboto button {
    font-family: "Roboto", sans-serif;
}

.roboto p {
    font-family: "Roboto", sans-serif;
}

.roboto li {
    font-family: "Roboto", sans-serif;
}

.roboto a {
    font-family: "Roboto", sans-serif;
}

.roboto div {
    font-family: "Roboto", sans-serif;
}

.roboto h1 {
    font-family: "Roboto", sans-serif;
}

.roboto h2 {
    font-family: "Roboto", sans-serif;
}

.roboto h3 {
    font-family: "Roboto", sans-serif;
}

.roboto h4 {
    font-family: "Roboto", sans-serif;
}

.roboto input {
    font-family: "Roboto", sans-serif;
}

.roboto textarea {
    font-family: "Roboto", sans-serif;
}

.roboto select {
    font-family: "Roboto", sans-serif;
}

.roboto option {
    font-family: "Roboto", sans-serif;
}


.alternate {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}




.alternate button {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate p {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate li {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate a {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate div {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate h1 {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate h2 {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate h3 {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate h4 {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate input {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate textarea {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate select {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}

.alternate option {
    font-family: Cambria, "Hoefler Text", "Liberation Serif", Times, "Times New Roman", "serif";
}





button {
background-color: transparent;
	  
	}



a:hover,
li a:hover {
  text-decoration: none;
  

}



@media (max-width: 766px) {
  
    .headerbar-homepage-container {
    display: none; 
  }
	
	
	.logo-mobile-homepage {
  position: fixed;
		  left: 20px;
	  top: 20px;
	  	z-index: 11;
	
}
	
	.logo-mobile-homepage img {
	width: 150px;
	height: 100%;
}

.mobile-headerbar-homepage {
  width: 100%;
	height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  transition: background-color 0.3s;
  background-color: transparent;
  z-index: 10;
}

.mobile-headerbar-homepage.scrolled {
  background-color: white;
}
	
  .mobile-menu-toggle {
    position: fixed;
	  right: 10px;
	  top: 10px;
	  	z-index: 11;
  }

  .mobile-menu-container {
    display: none;
   
  }


.mobile-menu-container {
    display: grid;
	position: fixed;
	gap: 10px;
	width: 100%;
	height: 100%;
	z-index: 10;
	background-color: #0028FF;
	  grid-template-rows: 50px 50px 50px 50px 25px 50px 50px 50px;
background-size: cover;
  }
	
	
.mobile-menu-container button,
.mobile-menu-toggle button {
    background: rgba(255, 255, 255, 0.2); 
    color: white;
    padding: 8px 18px; 
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 5px 2px;
    cursor: pointer;
    border-radius: 15px; 
    -webkit-backdrop-filter: blur(10px); 
            backdrop-filter: blur(10px); 
    border: 1px solid rgba(255, 255, 255, 0.5); 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    transition: all 0.3s ease; 
    position: relative; 
    overflow: hidden;
}
	
	
.mobile-menu-container button {
    width: 80%;
		font-size: 25px;
}
	
	
	.mobile-menu-container select {
    width: 80%;
		font-size: 25px;
}
	
	
	
	
	.mobile-menu-toggle.scrolled button {
    background: rgba(0, 40, 255, 1); 
    color: white;
    padding: 8px 18px; 
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 5px 2px;
    cursor: pointer;
    border-radius: 15px; 
    -webkit-backdrop-filter: blur(10px); 
            backdrop-filter: blur(10px); 
    border: 1px solid rgba(0, 40, 255, 0.5); 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    transition: all 0.3s ease; 
    position: relative; 
    overflow: hidden;
}
	
	
		.mobile-menu-toggle.scrolled button:hover {
    background: rgba(255, 255, 255, 1); 
    color: #0028FF;
       border: 1px solid rgba(0, 40, 255, 1); 
   }




.mobile-menu-container button::before,
.mobile-menu-toggle button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */
    transition: all 0.6s ease;
}

	.mobile-menu-container button:hover::before,
.mobile-menu-toggle button:hover::before {
    left: 100%;
}

.mobile-menu-container button:hover,
.mobile-menu-toggle button:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.3); 
    border: 1px solid #ffffff; 
}
	
.mobile-menu-container button.active,
.mobile-menu-toggle button.active {
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0); 
    border: 1px solid #ffffff;
}




	
}


@media (min-width: 767px) {
	
	
		.logo-mobile-homepage {
display: none;
	}

.headerbar-homepage {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transition: background-color 0.3s;
  background-color: transparent;
  z-index: 10; /* Ensure the header is above other content */
}

.headerbar-homepage.scrolled {
  background-color: white;
}

.headerbar-homepage-container {
	  display: grid;
  grid-template-columns: repeat(16, 1fr);
  gap: 5px; 
	margin: 5px 25px 5px 25px;
	justify-content: center;
  align-items: center; 
	min-height: 50px;
}
	
	.headerbar-homepage h1 {
		font-size: 25px;
		color: #ffffff;
		vertical-align: middle;
		margin-top: 13px;
	}
	
	
		.headerbar-homepage.scrolled h1{
		font-size: 25px;
		color: #0028FF;
		vertical-align: middle;
		margin-top: 13px;
	}

.logo-homepage {
  justify-content: center; /* Centers the content horizontally */
  align-items: center; /* Centers the content vertically */
  height: 20px; /* Adjust the height as needed */
  z-index: 1000;
}



.logo-homepage img {
	width: auto;
	height: 100%;
}





.headerbar-homepage button {
    background: rgba(255, 255, 255, 0.2); 
    color: white;
    border: none;
    padding: 8px 18px; 
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 15px;
    margin: 5px 2px;
    cursor: pointer;
    border-radius: 15px; 
    -webkit-backdrop-filter: blur(10px); 
            backdrop-filter: blur(10px); 
    border: 1px solid rgba(255, 255, 255, 0.5); 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    transition: all 0.3s ease; 
    position: relative; 
    overflow: hidden;
}


.headerbar-homepage.scrolled button {
    background: rgba(255, 255, 255, 0.2); 
    color: #0028ff;
    border: none;
    padding: 8px 18px; 
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 5px 2px;
    cursor: pointer;
    border-radius: 15px; 
    -webkit-backdrop-filter: blur(10px); 
            backdrop-filter: blur(10px); 
    border: 1px solid rgba(255, 255, 255, 0.5); 
    box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1); 
    transition: all 0.3s ease; 
    position: relative; 
    overflow: hidden;
}

.headerbar-homepage button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */
    transition: all 0.6s ease;
}

.headerbar-homepage button:hover::before {
    left: 100%;
}

.headerbar-homepage.scrolled button:hover {
    color: #0028ff;
    background: rgba(255, 255, 255, 0.3); 
    border: 1px solid rgba(0, 40, 255, 0.5); 
}

.headerbar-homepage button:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.3); 
    border: 1px solid #ffffff; 
}

.headerbar-homepage button.active {
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0); 
    border: 1px solid #ffffff;
}


.headerbar-homepage.scrolled button.active {
 color: #0028ff;
    background: rgba(255, 255, 255, 0.3); 
    border: 1px solid rgba(0, 40, 255, 0.5); 
}
	
	
	.mobile-headerbar-homepage {
    display: none; /* Hide the toggle button on large screens */
  }
	

  .mobile-menu-toggle {
    display: none; /* Hide the toggle button on large screens */
  }

  .mobile-menu-container {
    display: none; /* Ensure the mobile menu is not displayed on large screens */
  }
	
	}

.buzzbeat-starting-page {
  height: 120vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
	z-index: -1;
}


.buzzbeat-landing-page-background {
  height: 120vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
	z-index: 2;
	opacity: 0.5;
}



.buzzbeat-landing-page-black {
  height: 120vh;
  width: 100%;
	z-index: -1;
	position: absolute;
	top: 0px;
	background-color: #000000;
}




.buzzbeat-landing-page {
  height: 120vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
	z-index: 9;
	position: absolute;
	top: 0px;
}


.overlay-content {
  text-align: center;
  color: #FFFFFF;
  padding: 20px;
	padding-bottom: 20vh;
  max-width: 650px;
	    position: relative;

}


.overlay-content h1 {
  margin-bottom: 20px;
  font-size: 2.6rem;
	line-height: 1.3em;
}

.overlay-content p {
  margin-bottom: 30px;
  font-size: 1.7rem;
	line-height: 1.5em;
}


.overlay-content-landingpage {
  text-align: center;
  color: #FFFFFF;
  padding: 20px;
	padding-bottom: 20vh;
  max-width: 80%;
	    position: relativ;
}


.overlay-content-landingpage h1 {
    margin-bottom: 20px;
    font-size: 3.6rem;
    line-height: 1.3em;
    font-weight: 500;
    color: #FFFFFF; /* White color text */
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); 
}

.overlay-content-landingpage p {
    margin-bottom: 30px;
    font-size: 1.7rem;
    line-height: 1.5em;
    color: #FFFFFF; /* Ensures paragraph text is also white */
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5); /* Subtle text shadow for paragraphs */
}


.buzzbeat-other-page {
  height: 40vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
	z-index: -1;
}


.overlay-other-content {
  text-align: center;
  color: #FFFFFF;
  padding: 20px;
  max-width: 800px;
	    position: relative;

}

.overlay-other-content h1 {
  margin-bottom: 20px;
  font-size: 2.1rem; /* Large text */
}

.overlay-other-content p {
  margin-bottom: 30px;
  font-size: 1.4rem; /* Medium text */
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 20px; /* Space between buttons */
}

.btn {
  padding: 10px 20px;
  font-size: 1rem;
  color: #0028ff;
  background-color: rgba(255, 255, 255, 1);
	border: 1px solid #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
	color: #ffffff;
	border: 1px solid #FFFFFF;
}


@media only screen and (min-width: 767px) {


.content-section-homepage {
  padding: 40px; 
  margin: 80px 10% 80px 10%; 
  background-color: #ffffff; 
  border-radius: 15px; 
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}
	
	
	

.cookie-consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's above other content */
}
	
	
	.cookie-consent-modal {
  width: 90%;
  max-width: 610px;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

}


@media only screen and (max-width: 766px) {


.content-section-homepage {
  padding: 40px; 
  margin: 80px 2% 80px 2%; 
  background-color: #ffffff; 
  border-radius: 15px; 
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}
	
	
.cookie-consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
	
	
	.cookie-consent-modal {
  width: 98%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

}
	
.grid-layout {
  display: grid;
  grid-template-columns: repeat(6, 1fr); 
  gap: 10px; 
}

.grid-layout h1 {
    font-size: 35px;
	line-height: 1.5;
	    color: #0028ff;
      
    font-weight: 400;
}


.grid-content-item h1 {
    font-size: 30px;
	line-height: 1.5;
	    color: #0028ff;
      
    font-weight: 400;
}

.grid-layout h2 {
    color: #000000;
    font-size: 25px;
      
    font-weight: 400;
}


.grid-layout h3 {
    color: #000000;
    font-size: 20px;
      
    font-weight: 400;
}


.grid-layout p {
    color: #000000;
    font-size: 20px;
      
    font-weight: 300;
}

.center {
	text-align: center;
	align-content: center;
}

.grid-content-item {
  padding: 10px; /* Increased padding for more space inside grid items */
  border-radius: 10px; /* Larger border radius for grid items */
  flex-direction: column; /* Stack children vertically */
  justify-content: space-between; /* Distribute space inside the item */
  transition: all 0.3s ease; /* Smooth transition for hover effects */
}

.grid-content-item img {
	max-width: 100%;
	height: auto;
}

.grid-item {
  background: linear-gradient(145deg, #f5f5f5, #ffffff); /* Subtle gradient for a more dynamic look */
  padding: 10px; /* Increased padding for more space inside grid items */
  border-radius: 10px; /* Larger border radius for grid items */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); /* Softer shadow for a subtle depth effect */
  display: flex; /* Flex display to better manage the content inside */
  flex-direction: column; /* Stack children vertically */
  justify-content: space-between; /* Distribute space inside the item */
  transition: all 0.3s ease; /* Smooth transition for hover effects */
}

.grid-item:hover {
  transform: translateY(-5px); /* Slight lift effect on hover */
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1); /* Increased shadow on hover for a popping effect */
}


.grid-item p {
    color: #000000;
    font-size: 15px;
      
    font-weight: 300;
}


.inner-grid-item {
  grid-template-rows: repeat(3, 1fr);
  gap: 10px;
}

.inner-grid-item > div:nth-child(1) {
  height: 70px;
}

.inner-grid-item > div:nth-child(2) {
  height: 65px;
}

.inner-grid-item > div:nth-child(3) {
}




.action {
    background: rgba(0, 40, 255, 1); 
    color: white;
    border: none;
    padding: 12px 25px; 
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 5px 6px;
    cursor: pointer;
    border-radius: 15px; 
    -webkit-backdrop-filter: blur(10px); 
            backdrop-filter: blur(10px); 
    border: 1px solid rgba(255, 255, 255, 0.5); 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    transition: all 0.3s ease; 
    position: relative; 
    overflow: hidden;
}



.action::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */
    transition: all 0.6s ease;
}

.action:hover::before {
    left: 100%;
}


.action:hover {
    color: #ffffff;
    background: rgba(0, 40, 255, 1); 
    border: 1px solid #ffffff; 
}




.small-icon {
      width: 45px;
  height: auto;
    }


.counter-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.counter {
    text-align: center;
}

.counter p {
    color: #333;
    font-size: 20px;
    margin-top: 10px;
}

.counter h1 {
    font-size: 70px;
    font-weight: 500;
    color: #0028ff;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  gap: 10px; 
  margin: 60px 40px 80px 40px;
}

.news-inner-grid {
  display: grid;
  grid-template-rows: 280px 80px;
  gap: 10px; 
  background-color: #ffffff;
  padding: 8px;
	cursor: pointer;
}

.news-inner-grid > div {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}



.news-inner-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0; 
  left: 0;
}

.news-inner-grid > div:nth-child(2) {
  background-color: #ffffff;
}


.news-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;
}


.news-modal-content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    padding: 20px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: left;
    overflow-y: auto;
	 display: flex;
    flex-direction: column;
	height: 90%;
	width: 70%;
}

.news-modal-content p {
  font-size: 20px;
}

.news-modal-content h2 {
  font-size: 22px;
	font-weight: 500;
}

.news-modal-content-img {
  position: relative;
  text-align: left;
  height: 350px;
  width: 100%;
	margin-bottom: 25px;
}

.news-modal-content-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-title {
  position: absolute;
  bottom: 10px; 
  left: 10px; 
	right: 10px;
  color: white; 
  padding: 5px;
	font-size: 65px;
}

.screen-container {
    position: relative;
    width: 100%; 
    height: 0; 
    padding-top: 70%;
}

.screenshot, .screen-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.screenshot img, .screen-image {
    object-fit: cover; 
}

.screen-image {
    z-index: 2; 
}

.screenshot {
    z-index: 1; 
    display: flex;
    justify-content: center;
    align-items: center;
}

.screenshot img {
      width: 90%;
    margin-top: -22%;
}

@media only screen and (min-width: 767px) {


.pricing-container {
  display: grid;
  grid-template-columns: auto 130px 130px 150px 130px;
  gap: 10px;
  background-color: #ffffff;
  padding: 8px;
  cursor: pointer;
}

}


@media only screen and (max-width: 766px) {


.pricing-container {
  
  gap: 10px;
  background-color: #ffffff;
  padding: 8px;
  cursor: pointer;
}

}

.features-list {
  display: grid;
  grid-template-rows: repeat(21, 1fr);
  gap: 10px; 
  background-color: #ffffff;
	cursor: pointer;
}


.features-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
}

.feature {
	  display: grid;
  grid-template-rows: repeat(21, 1fr);
	gap: 10px;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #ffffff;
    transition: transform 0.3s ease;
}

.feature:hover {
    transform: scale(1.05);
    	 border: 1px solid #0028ff;
}


.feature h1 {
 font-size: 22px;
      
    font-weight: 500;
	margin-top: 5px;
	margin-bottom: 10px;
	text-align: center;
}


.feature h2 {
 font-size: 18px;
      
    font-weight: 300;
	margin-top: 5px;
	margin-bottom: 10px;
}

.feature-checkmark, .feature-features {
  display: flex;
  align-items: center; 
  justify-content: start; 
  padding-left: 8px;
	padding-right: 8px;
}


.feature-checkmark span {
	width: 100%;
  text-align: center;
	font-size: 20px;
	  
	font-weight: 500;
}


.feature-features span {
	width: 100%;
  text-align: left;
	font-size: 15px;
	  
	font-weight: 300;
}


.feature-checkmark.even-row, .feature-features.even-row {
  background-color: #F5F5F5; 
}

.feature-checkmark.odd-row, .feature-features.odd-row {
  background-color: #ffffff; 
}

.highlighted {
  background-color: #ffffff; 
		border: 1px #0028FF solid;

}

.bestseller-tag {
  display: inline-block;
  background-image: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  color: #ffffff; 
  padding: 8px 15px; 
  border-radius: 20px; 
  margin-top: 3px; 
  margin-bottom: 3px; 
  text-align: center;
  font-weight: bold; 
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  letter-spacing: 1px; 
  font-size: 15px; 
  transition: all 0.3s ease; 
}

.bestseller-tag:hover {
  background-image: linear-gradient(to right, #fda085 0%, #f6d365 100%);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.25); /* More pronounced shadow on hover */
  transform: translateY(-2px); /* Slight lift effect */
}







.cookie-consent-modal h2 {
  margin-top: 0;
}

.cookie-consent-modal .actions {
  margin-top: 20px;
}

.cookie-consent-modal button {
  padding: 10px 20px;
  margin: 0 10px;
  border: none;
  background-color: #0028FF;
  color: white;
  cursor: pointer;
  border-radius: 5px;
	    border: 1px solid #0028ff;
	font-size: 15px;

}

.cookie-consent-modal button:hover {
  background: #ffffff;
	      border: 1px solid #0028ff;
	color: #0028ff;

}


.cookie-consent-modal button.manage-consent {
  padding: 10px 20px;
  margin: 0 10px;
  border: none;
  background-color: #0028FF;
  color: white;
  cursor: pointer;
  border-radius: 5px;
	    border: 1px solid #0028ff;
	font-size: 15px;
	opacity: 0.5

}

.cookie-consent-modal button:hover.manage-consent {
  background: #ffffff;
	      border: 1px solid #0028ff;
	color: #0028ff;

}











.main-container {
  display: flex;
  flex-direction: column;
	padding-top: 80px;
  min-height: 100vh;
}


.content-homepage {
  flex-grow: 1;
  margin: 30px;
  background-color: #ffffff;
  scroll-behavior: auto;
}








@keyframes glowing {
    0% { background-position: 0 0; }
    50% { background-position: 400% 0; }
    100% { background-position: 0 0; }
}




.right-nav-bar-homepage {
  position: fixed;
	 grid-column: 3;
	z-index: 999;
	right: 30px;
	top: 14px;
	background-color: #ffffff;
	display: flex;
    justify-content: right;
    gap: 5px;
}


.right-nav-bar-homepage button {
	font-size: 15px;
  margin: 0px 0px 0px 0px;
  padding: 10px 15px 10px 15px;
  color: #ffffff;
  text-decoration: none;
  position: relative;
  z-index: 0;
  transition: all 0.5s ease-in-out;
  background: #000000;
	cursor: pointer;
	  
	font-weight: 500;
	width: 100%;
	border: 1px #000000 solid;
	text-align: left;
	 display: inline;
	border-radius: 25px;
		   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.4);

}

.right-nav-bar-homepage button:hover {
	opacity: 0.5;
			   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.9);
	}


.right-nav-bar-homepage .active {
	
  color: #000000;
    background: #ffffff;
	}

.right-nav-bar-homepage select {
	
 margin-right: 0px;
	}


.buy-button, .test-button {
  margin-top: 5px;
	margin-bottom: 5px;
  padding: 8px 26px;
   cursor: pointer;
  font-weight: bold;
   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);
	border: 1px #000000 solid;
}

.buy-button {
  background-color: #000000;
  color: white;
}

.test-button {
  background-color: #000000;
  color: white;
}

.buy-button:hover, .test-button:hover {
  background-color: #ffffff;
	color: #000000;
}



.toggle-button {
  padding: 10px 15px;
	margin-bottom: 25px;
  color: #ffffff;
	background-color: #000000;
  cursor: pointer;
  font-size: 20px;
	border: 1px solid #000000;
	transition: background-color 0.5s, color 0.5s;
	   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);

}


.toggle-button:hover {
   background-color: #ffffff;
  color: #000000;
 }


table .checkmark {
  color: #000000;
}

td.empty {
	border: 0px solid #ddd;
	background-color: #ffffff;
}

th.empty {
	border: 0px solid #ddd;
	background-color: #ffffff;
}
















.headerbar li {
  position: relative;
  display: inline;
  color: #ffffff;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 28px;
}

.headerbar p {
  position: relative;
  display: inline;
  color: #ffffff;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 28px;
  font-size: 14px;
}


.headerbar li a {
  color: #ffffff;
  font-size: 14px;
}

.headerbar li a:hover {
  color: #ffffff;
  font-size: 14px;
  text-decoration: underline;
}

.headerbar a {
  color: #ffffff;
  text-decoration: none;
}

.headerbar a:hover {
  text-decoration: underline;
}







.bottombar li {
  position: relative;
  display: inline;
  color: #000000;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 30px;
}

.bottombar li a {
  color: #000000;
  font-size: 14px;
}

.bottombar li a:hover {
  color: #000000;
  font-size: 14px;
  text-decoration: underline;
}

.bottombar a {
  color: #000000;
  text-decoration: none;
}

.bottombar a:hover {
  text-decoration: underline;
}


.presslist th {
text-align: left;
	vertical-align: bottom;
}

.presslist td {
min-width: 20px;
	vertical-align: bottom;
}

 #chat-history {
            flex: 2 1;
             padding: 3px 5px;
  font-size: 20px;
  border: solid 1px;
  border-color: #000000;
  margin-top: 10px;
	 bottom: 50px;
	 max-height: 450px;
          overflow-y: scroll;
	
	overflow-anchor: none;
        }


select, textarea, input {
  width: calc(100% - 5px);
  padding: 8px;
	margin: 5px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 14px;
	}

select:focus, select:hover, textarea:focus, textarea:hover, input:focus, input:hover {
  outline: none;
  border-color: #0028FF;
}




.language-switcher select {
  width: 100%;
	font-size: 14px;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
	margin: 0px;
}



ul {
  display: block;
  list-style-type: disc;
  margin: 0;
  padding-inline-start: 0;
}





.login-landingpage-container {
  display: flex;
  justify-content: center;
  align-items: center;
		margin-bottom: 50px;
}


.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.login-form {
  width: 500px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
	background-color: #ffffff;
	border: 1px solid #0028FF;
}

.login-form a {
    border: 1px solid #fff;
  border-radius: 10px;
	color: #0028FF;
	padding: 3px 8px 3px 8px;
}

.login-form a:hover {
    border: 1px solid #0028FF;
}

.login-form .error-message {
    color: #0028FF;
}

.login-form .success-message {
    color: #0028FF;
}


.login-form h1 {
 font-size: 20px;
	color: #0028FF;
}

.login-form label {
  color: #000000;
}

.login-form input {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
}


.login-form button {
    background-color: #0028ff;
    color: #fff;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
	margin-bottom: 10px;
	vertical-align: middle;
	  border: 1px solid #0028ff;
}

.login-form button:hover {
background-color: #ffffff;
	color: #0028ff;
		  border: 1px solid #0028ff;

}


.additional-options button {
    background-color: #ffffff;
    color: #0028ff;
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
	vertical-align: middle;
	border: 1px solid #ffffff;
	margin: 12px 3px 0px 3px;

}

.additional-options button:hover {
background-color: #ffffff;
	color: #0028ff;
border: 1px solid #0028ff;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .login-form {
    width: 90%;
  }
}


.product-features-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 2rem;
  background-color: #f8f9fa; /* Light grey background */
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0,0,0,0.2);
}

.feature-item img {
  width: 100%;
  height: auto;
  object-fit: cover; /* Ensures the image covers the area nicely */
}

.feature-item p {
  padding: 1rem;
  font-size: 1rem;
  color: #333; /* Dark grey text for readability */
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .product-features-container {
    grid-template-columns: 1fr; /* Stack items in a single column on smaller screens */
  }
}



  .close-button {
    float: right;
    border: none;
    background: none;
    font-size: 30px;
	max-width: 25px;
	border-radius: 10px;
	padding: 5px;
}

.close-button:hover {
    background-color: #000000;
	color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/HomePage.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;;;;;;EAOE,cAAc;AAChB;;;AAGA;IACI,iCAAiC;AACrC;;;AAGA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;;AAGA;IACI,2FAA2F;AAC/F;;;;;AAKA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2FAA2F;AAC/F;;;;;;AAMA;AACA,6BAA6B;;CAE5B;;;;AAID;;EAEE,qBAAqB;;;AAGvB;;;;AAIA;;IAEI;IACA,aAAa;EACf;;;CAGD;EACC,eAAe;IACb,UAAU;GACX,SAAS;IACR,WAAW;;AAEf;;CAEC;CACA,YAAY;CACZ,YAAY;AACb;;AAEA;EACE,WAAW;CACZ,YAAY;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;EAEE;IACE,eAAe;GAChB,WAAW;GACX,SAAS;IACR,WAAW;EACb;;EAEA;IACE,aAAa;;EAEf;;;AAGF;IACI,aAAa;CAChB,eAAe;CACf,SAAS;CACT,WAAW;CACX,YAAY;CACZ,WAAW;CACX,yBAAyB;GACvB,2DAA2D;AAC9D,sBAAsB;EACpB;;;AAGF;;IAEI,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,UAAU;EACZ,eAAe;AACjB;;;CAGC;IACG,UAAU;EACZ,eAAe;AACjB;;;;;CAKC;IACG,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,uCAAuC;IACvC,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;EAGE;IACE,kCAAkC;IAClC,cAAc;OACX,qCAAqC;GACzC;;;;;AAKH;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uFAAuF,EAAE,uBAAuB;IAChH,yBAAyB;AAC7B;;CAEC;;IAEG,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,wCAAwC;IACxC,yBAAyB;AAC7B;;;;;;AAMA;;;AAGA;;;EAGE;AACF,aAAa;CACZ;;AAED;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,6BAA6B;EAC7B,WAAW,EAAE,6CAA6C;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;GACG,aAAa;EACd,sCAAsC;EACtC,QAAQ;CACT,yBAAyB;CACzB,uBAAuB;EACtB,mBAAmB;CACpB,gBAAgB;AACjB;;CAEC;EACC,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;CACjB;;;EAGC;EACA,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;CACjB;;AAED;EACE,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB,EAAE,mCAAmC;EACxD,YAAY,EAAE,gCAAgC;EAC9C,aAAa;AACf;;;;AAIA;CACC,WAAW;CACX,YAAY;AACb;;;;;;AAMA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,oCAAoC;IACpC,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,8CAA8C;IAC9C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uFAAuF,EAAE,uBAAuB;IAChH,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,yBAAyB;AAC7B;;;AAGA;CACC,cAAc;IACX,oCAAoC;IACpC,uCAAuC;AAC3C;;;CAGC;IACG,aAAa,EAAE,4CAA4C;EAC7D;;;EAGA;IACE,aAAa,EAAE,4CAA4C;EAC7D;;EAEA;IACE,aAAa,EAAE,6DAA6D;EAC9E;;CAED;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB,WAAW;AACZ;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB,UAAU;CACV,YAAY;AACb;;;;AAIA;EACE,aAAa;EACb,WAAW;CACZ,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,yBAAyB;AAC1B;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB,UAAU;CACV,kBAAkB;CAClB,QAAQ;AACT;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;CACd,oBAAoB;EACnB,gBAAgB;KACb,kBAAkB;;AAEvB;;;AAGA;EACE,mBAAmB;EACnB,iBAAiB;CAClB,kBAAkB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;CAClB,kBAAkB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;CACd,oBAAoB;EACnB,cAAc;KACX,iBAAiB;AACtB;;;AAGA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc,EAAE,qBAAqB;IACrC,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAE,yCAAyC;IACzD,yCAAyC,EAAE,sCAAsC;AACrF;;;AAGA;EACE,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB,WAAW;AACZ;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;KACb,kBAAkB;;AAEvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB,EAAE,eAAe;AACpC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,wCAAwC;CACzC,yBAAyB;EACxB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;CAC3C,cAAc;CACd,yBAAyB;AAC1B;;;AAGA;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;;;;AAKA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,oCAAoC;AACrD;;;CAGC;EACC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;;AAGA;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;;CAGC;EACC,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;IACI,eAAe;CAClB,gBAAgB;KACZ,cAAc;;IAEf,gBAAgB;AACpB;;;AAGA;IACI,eAAe;CAClB,gBAAgB;KACZ,cAAc;;IAEf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;;IAEf,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,eAAe;;IAEf,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;EACE,aAAa,EAAE,uDAAuD;EACtE,mBAAmB,EAAE,wCAAwC;EAC7D,sBAAsB,EAAE,8BAA8B;EACtD,8BAA8B,EAAE,qCAAqC;EACrE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;EACE,qDAAqD,EAAE,4CAA4C;EACnG,aAAa,EAAE,uDAAuD;EACtE,mBAAmB,EAAE,wCAAwC;EAC7D,0CAA0C,EAAE,4CAA4C;EACxF,aAAa,EAAE,qDAAqD;EACpE,sBAAsB,EAAE,8BAA8B;EACtD,8BAA8B,EAAE,qCAAqC;EACrE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,2BAA2B,EAAE,gCAAgC;EAC7D,yCAAyC,EAAE,mDAAmD;AAChG;;;AAGA;IACI,cAAc;IACd,eAAe;;IAEf,gBAAgB;AACpB;;;AAGA;EACE,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;;;;AAKA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uFAAuF,EAAE,uBAAuB;IAChH,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,cAAc;IACd,+BAA+B;IAC/B,yBAAyB;AAC7B;;;;;AAKA;MACM,WAAW;EACf,YAAY;IACV;;;AAGJ;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,YAAY;CACb,eAAe;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB,aAAa;IACX,sBAAsB;CACzB,WAAW;CACX,UAAU;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;CAChB,gBAAgB;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;CACZ,mBAAmB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;CACX,WAAW;EACV,YAAY;EACZ,YAAY;CACb,eAAe;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;MACM,UAAU;IACZ,gBAAgB;AACpB;;AAEA;;;AAGA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;AAGA;;;AAGA;;EAEE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,yBAAyB;CAC1B,eAAe;AAChB;;;AAGA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;GACG,aAAa;EACd,mCAAmC;CACpC,SAAS;IACN,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;MACpB,yBAAyB;AAC/B;;;AAGA;CACC,eAAe;;IAEZ,gBAAgB;CACnB,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;;AAGA;CACC,eAAe;;IAEZ,gBAAgB;CACnB,eAAe;CACf,mBAAmB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;CAClB,kBAAkB;AACnB;;;AAGA;CACC,WAAW;EACV,kBAAkB;CACnB,eAAe;;CAEf,gBAAgB;AACjB;;;AAGA;CACC,WAAW;EACV,gBAAgB;CACjB,eAAe;;CAEf,gBAAgB;AACjB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;;AAE3B;;AAEA;EACE,qBAAqB;EACrB,mEAAmE;EACnE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,4CAA4C,EAAE,oCAAoC;EAClF,2BAA2B,EAAE,uBAAuB;AACtD;;;;;;;;AAQA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;KACf,yBAAyB;CAC7B,eAAe;;AAEhB;;AAEA;EACE,mBAAmB;OACd,yBAAyB;CAC/B,cAAc;;AAEf;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;KACf,yBAAyB;CAC7B,eAAe;CACf;;AAED;;AAEA;EACE,mBAAmB;OACd,yBAAyB;CAC/B,cAAc;;AAEf;;;;;;;;;;;;AAYA;EACE,aAAa;EACb,sBAAsB;CACvB,iBAAiB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;;;;;;;;AASA;IACI,KAAK,wBAAwB,EAAE;IAC/B,MAAM,2BAA2B,EAAE;IACnC,OAAO,wBAAwB,EAAE;AACrC;;;;;AAKA;EACE,eAAe;EACf,cAAc;CACf,YAAY;CACZ,WAAW;CACX,SAAS;CACT,yBAAyB;CACzB,aAAa;IACV,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;CACC,eAAe;EACd,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,mBAAmB;CACpB,eAAe;;CAEf,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB,gBAAgB;EACf,eAAe;CAChB,mBAAmB;KACf,+CAA+C;;AAEpD;;AAEA;CACC,YAAY;MACP,+CAA+C;CACpD;;;AAGD;;EAEE,cAAc;IACZ,mBAAmB;CACtB;;AAED;;CAEC,iBAAiB;CACjB;;;AAGD;EACE,eAAe;CAChB,kBAAkB;EACjB,iBAAiB;GAChB,eAAe;EAChB,iBAAiB;GAChB,+CAA+C;CACjD,yBAAyB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;CAC1B,cAAc;AACf;;;;AAIA;EACE,kBAAkB;CACnB,mBAAmB;EAClB,cAAc;CACf,yBAAyB;EACxB,eAAe;EACf,eAAe;CAChB,yBAAyB;CACzB,6CAA6C;IAC1C,+CAA+C;;AAEnD;;;AAGA;GACG,yBAAyB;EAC1B,cAAc;CACf;;;AAGD;EACE,cAAc;AAChB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;AAC1B;;;;;;;;;;;;;;;;;AAiBA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;;;;;;AAQA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;AACA,gBAAgB;CACf,sBAAsB;AACvB;;AAEA;AACA,eAAe;CACd,sBAAsB;AACvB;;CAEC;YACW,SAAO;aACN,gBAAgB;EAC3B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;UACT,kBAAkB;;CAE3B,qBAAqB;QACd;;;AAGR;EACE,uBAAuB;EACvB,YAAY;CACb,WAAW;EACV,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;CAChB;;AAED;EACE,aAAa;EACb,qBAAqB;AACvB;;;;;AAKA;EACE,WAAW;CACZ,eAAe;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;CACvB,WAAW;AACZ;;;;AAIA;EACE,cAAc;EACd,qBAAqB;EACrB,SAAS;EACT,uBAAuB;AACzB;;;;;;AAMA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;CACpB,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;IACI,sBAAsB;EACxB,mBAAmB;CACpB,cAAc;CACd,wBAAwB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,oBAAoB;CACvB,mBAAmB;CACnB,sBAAsB;GACpB,yBAAyB;AAC5B;;AAEA;AACA,yBAAyB;CACxB,cAAc;IACX,yBAAyB;;AAE7B;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;CACvB,sBAAsB;CACtB,yBAAyB;CACzB,wBAAwB;;AAEzB;;AAEA;AACA,yBAAyB;CACxB,cAAc;AACf,yBAAyB;AACzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAE,mCAAmC;EAChD,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B,EAAE,sDAAsD;EACpF;AACF;;;;EAIE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;CAClB,eAAe;CACf,mBAAmB;CACnB,YAAY;AACb;;AAEA;IACI,yBAAyB;CAC5B,cAAc;AACf","sourcesContent":["@charset \"utf-8\";\n \n.color-accent,\n.color-accent-hover:hover,\n.color-accent-hover:focus,\n:root .has-accent-color,\n.has-drop-cap:not(:focus):first-letter,\n.wp-block-button.is-style-outline,\na {\n  color: #000000;\n}\n\n\n.roboto {\n    font-family: \"Roboto\", sans-serif;\n}\n\n\n.roboto button {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto p {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto li {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto a {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto div {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto h1 {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto h2 {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto h3 {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto h4 {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto input {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto textarea {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto select {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.roboto option {\n    font-family: \"Roboto\", sans-serif;\n}\n\n\n.alternate {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n\n\n\n.alternate button {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate p {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate li {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate a {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate div {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate h1 {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate h2 {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate h3 {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate h4 {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate input {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate textarea {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate select {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n.alternate option {\n    font-family: Cambria, \"Hoefler Text\", \"Liberation Serif\", Times, \"Times New Roman\", \"serif\";\n}\n\n\n\n\n\nbutton {\nbackground-color: transparent;\n\t  \n\t}\n\n\n\na:hover,\nli a:hover {\n  text-decoration: none;\n  \n\n}\n\n\n\n@media (max-width: 766px) {\n  \n    .headerbar-homepage-container {\n    display: none; \n  }\n\t\n\t\n\t.logo-mobile-homepage {\n  position: fixed;\n\t\t  left: 20px;\n\t  top: 20px;\n\t  \tz-index: 11;\n\t\n}\n\t\n\t.logo-mobile-homepage img {\n\twidth: 150px;\n\theight: 100%;\n}\n\n.mobile-headerbar-homepage {\n  width: 100%;\n\theight: 70px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  transition: background-color 0.3s;\n  background-color: transparent;\n  z-index: 10;\n}\n\n.mobile-headerbar-homepage.scrolled {\n  background-color: white;\n}\n\t\n  .mobile-menu-toggle {\n    position: fixed;\n\t  right: 10px;\n\t  top: 10px;\n\t  \tz-index: 11;\n  }\n\n  .mobile-menu-container {\n    display: none;\n   \n  }\n\n\n.mobile-menu-container {\n    display: grid;\n\tposition: fixed;\n\tgap: 10px;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 10;\n\tbackground-color: #0028FF;\n\t  grid-template-rows: 50px 50px 50px 50px 25px 50px 50px 50px;\nbackground-size: cover;\n  }\n\t\n\t\n.mobile-menu-container button,\n.mobile-menu-toggle button {\n    background: rgba(255, 255, 255, 0.2); \n    color: white;\n    padding: 8px 18px; \n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 18px;\n    margin: 5px 2px;\n    cursor: pointer;\n    border-radius: 15px; \n    backdrop-filter: blur(10px); \n    border: 1px solid rgba(255, 255, 255, 0.5); \n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    transition: all 0.3s ease; \n    position: relative; \n    overflow: hidden;\n}\n\t\n\t\n.mobile-menu-container button {\n    width: 80%;\n\t\tfont-size: 25px;\n}\n\t\n\t\n\t.mobile-menu-container select {\n    width: 80%;\n\t\tfont-size: 25px;\n}\n\t\n\t\n\t\n\t\n\t.mobile-menu-toggle.scrolled button {\n    background: rgba(0, 40, 255, 1); \n    color: white;\n    padding: 8px 18px; \n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 18px;\n    margin: 5px 2px;\n    cursor: pointer;\n    border-radius: 15px; \n    backdrop-filter: blur(10px); \n    border: 1px solid rgba(0, 40, 255, 0.5); \n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    transition: all 0.3s ease; \n    position: relative; \n    overflow: hidden;\n}\n\t\n\t\n\t\t.mobile-menu-toggle.scrolled button:hover {\n    background: rgba(255, 255, 255, 1); \n    color: #0028FF;\n       border: 1px solid rgba(0, 40, 255, 1); \n   }\n\n\n\n\n.mobile-menu-container button::before,\n.mobile-menu-toggle button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */\n    transition: all 0.6s ease;\n}\n\n\t.mobile-menu-container button:hover::before,\n.mobile-menu-toggle button:hover::before {\n    left: 100%;\n}\n\n.mobile-menu-container button:hover,\n.mobile-menu-toggle button:hover {\n    color: #ffffff;\n    background: rgba(255, 255, 255, 0.3); \n    border: 1px solid #ffffff; \n}\n\t\n.mobile-menu-container button.active,\n.mobile-menu-toggle button.active {\n    color: #ffffff;\n    background-color: rgba(255, 255, 255, 0); \n    border: 1px solid #ffffff;\n}\n\n\n\n\n\t\n}\n\n\n@media (min-width: 767px) {\n\t\n\t\n\t\t.logo-mobile-homepage {\ndisplay: none;\n\t}\n\n.headerbar-homepage {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  transition: background-color 0.3s;\n  background-color: transparent;\n  z-index: 10; /* Ensure the header is above other content */\n}\n\n.headerbar-homepage.scrolled {\n  background-color: white;\n}\n\n.headerbar-homepage-container {\n\t  display: grid;\n  grid-template-columns: repeat(16, 1fr);\n  gap: 5px; \n\tmargin: 5px 25px 5px 25px;\n\tjustify-content: center;\n  align-items: center; \n\tmin-height: 50px;\n}\n\t\n\t.headerbar-homepage h1 {\n\t\tfont-size: 25px;\n\t\tcolor: #ffffff;\n\t\tvertical-align: middle;\n\t\tmargin-top: 13px;\n\t}\n\t\n\t\n\t\t.headerbar-homepage.scrolled h1{\n\t\tfont-size: 25px;\n\t\tcolor: #0028FF;\n\t\tvertical-align: middle;\n\t\tmargin-top: 13px;\n\t}\n\n.logo-homepage {\n  justify-content: center; /* Centers the content horizontally */\n  align-items: center; /* Centers the content vertically */\n  height: 20px; /* Adjust the height as needed */\n  z-index: 1000;\n}\n\n\n\n.logo-homepage img {\n\twidth: auto;\n\theight: 100%;\n}\n\n\n\n\n\n.headerbar-homepage button {\n    background: rgba(255, 255, 255, 0.2); \n    color: white;\n    border: none;\n    padding: 8px 18px; \n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 15px;\n    margin: 5px 2px;\n    cursor: pointer;\n    border-radius: 15px; \n    backdrop-filter: blur(10px); \n    border: 1px solid rgba(255, 255, 255, 0.5); \n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    transition: all 0.3s ease; \n    position: relative; \n    overflow: hidden;\n}\n\n\n.headerbar-homepage.scrolled button {\n    background: rgba(255, 255, 255, 0.2); \n    color: #0028ff;\n    border: none;\n    padding: 8px 18px; \n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 18px;\n    margin: 5px 2px;\n    cursor: pointer;\n    border-radius: 15px; \n    backdrop-filter: blur(10px); \n    border: 1px solid rgba(255, 255, 255, 0.5); \n    box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1); \n    transition: all 0.3s ease; \n    position: relative; \n    overflow: hidden;\n}\n\n.headerbar-homepage button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */\n    transition: all 0.6s ease;\n}\n\n.headerbar-homepage button:hover::before {\n    left: 100%;\n}\n\n.headerbar-homepage.scrolled button:hover {\n    color: #0028ff;\n    background: rgba(255, 255, 255, 0.3); \n    border: 1px solid rgba(0, 40, 255, 0.5); \n}\n\n.headerbar-homepage button:hover {\n    color: #ffffff;\n    background: rgba(255, 255, 255, 0.3); \n    border: 1px solid #ffffff; \n}\n\n.headerbar-homepage button.active {\n    color: #ffffff;\n    background-color: rgba(255, 255, 255, 0); \n    border: 1px solid #ffffff;\n}\n\n\n.headerbar-homepage.scrolled button.active {\n color: #0028ff;\n    background: rgba(255, 255, 255, 0.3); \n    border: 1px solid rgba(0, 40, 255, 0.5); \n}\n\t\n\t\n\t.mobile-headerbar-homepage {\n    display: none; /* Hide the toggle button on large screens */\n  }\n\t\n\n  .mobile-menu-toggle {\n    display: none; /* Hide the toggle button on large screens */\n  }\n\n  .mobile-menu-container {\n    display: none; /* Ensure the mobile menu is not displayed on large screens */\n  }\n\t\n\t}\n\n.buzzbeat-starting-page {\n  height: 120vh;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\tz-index: -1;\n}\n\n\n.buzzbeat-landing-page-background {\n  height: 120vh;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\tz-index: 2;\n\topacity: 0.5;\n}\n\n\n\n.buzzbeat-landing-page-black {\n  height: 120vh;\n  width: 100%;\n\tz-index: -1;\n\tposition: absolute;\n\ttop: 0px;\n\tbackground-color: #000000;\n}\n\n\n\n\n.buzzbeat-landing-page {\n  height: 120vh;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\tz-index: 9;\n\tposition: absolute;\n\ttop: 0px;\n}\n\n\n.overlay-content {\n  text-align: center;\n  color: #FFFFFF;\n  padding: 20px;\n\tpadding-bottom: 20vh;\n  max-width: 650px;\n\t    position: relative;\n\n}\n\n\n.overlay-content h1 {\n  margin-bottom: 20px;\n  font-size: 2.6rem;\n\tline-height: 1.3em;\n}\n\n.overlay-content p {\n  margin-bottom: 30px;\n  font-size: 1.7rem;\n\tline-height: 1.5em;\n}\n\n\n.overlay-content-landingpage {\n  text-align: center;\n  color: #FFFFFF;\n  padding: 20px;\n\tpadding-bottom: 20vh;\n  max-width: 80%;\n\t    position: relativ;\n}\n\n\n.overlay-content-landingpage h1 {\n    margin-bottom: 20px;\n    font-size: 3.6rem;\n    line-height: 1.3em;\n    font-weight: 500;\n    color: #FFFFFF; /* White color text */\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); \n}\n\n.overlay-content-landingpage p {\n    margin-bottom: 30px;\n    font-size: 1.7rem;\n    line-height: 1.5em;\n    color: #FFFFFF; /* Ensures paragraph text is also white */\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5); /* Subtle text shadow for paragraphs */\n}\n\n\n.buzzbeat-other-page {\n  height: 40vh;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\tz-index: -1;\n}\n\n\n.overlay-other-content {\n  text-align: center;\n  color: #FFFFFF;\n  padding: 20px;\n  max-width: 800px;\n\t    position: relative;\n\n}\n\n.overlay-other-content h1 {\n  margin-bottom: 20px;\n  font-size: 2.1rem; /* Large text */\n}\n\n.overlay-other-content p {\n  margin-bottom: 30px;\n  font-size: 1.4rem; /* Medium text */\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px; /* Space between buttons */\n}\n\n.btn {\n  padding: 10px 20px;\n  font-size: 1rem;\n  color: #0028ff;\n  background-color: rgba(255, 255, 255, 1);\n\tborder: 1px solid #FFFFFF;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n\tcolor: #ffffff;\n\tborder: 1px solid #FFFFFF;\n}\n\n\n@media only screen and (min-width: 767px) {\n\n\n.content-section-homepage {\n  padding: 40px; \n  margin: 80px 10% 80px 10%; \n  background-color: #ffffff; \n  border-radius: 15px; \n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n}\n\t\n\t\n\t\n\n.cookie-consent-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Ensure it's above other content */\n}\n\t\n\t\n\t.cookie-consent-modal {\n  width: 90%;\n  max-width: 610px;\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n}\n\n\n@media only screen and (max-width: 766px) {\n\n\n.content-section-homepage {\n  padding: 40px; \n  margin: 80px 2% 80px 2%; \n  background-color: #ffffff; \n  border-radius: 15px; \n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n}\n\t\n\t\n.cookie-consent-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\t\n\t\n\t.cookie-consent-modal {\n  width: 98%;\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n}\n\t\n.grid-layout {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr); \n  gap: 10px; \n}\n\n.grid-layout h1 {\n    font-size: 35px;\n\tline-height: 1.5;\n\t    color: #0028ff;\n      \n    font-weight: 400;\n}\n\n\n.grid-content-item h1 {\n    font-size: 30px;\n\tline-height: 1.5;\n\t    color: #0028ff;\n      \n    font-weight: 400;\n}\n\n.grid-layout h2 {\n    color: #000000;\n    font-size: 25px;\n      \n    font-weight: 400;\n}\n\n\n.grid-layout h3 {\n    color: #000000;\n    font-size: 20px;\n      \n    font-weight: 400;\n}\n\n\n.grid-layout p {\n    color: #000000;\n    font-size: 20px;\n      \n    font-weight: 300;\n}\n\n.center {\n\ttext-align: center;\n\talign-content: center;\n}\n\n.grid-content-item {\n  padding: 10px; /* Increased padding for more space inside grid items */\n  border-radius: 10px; /* Larger border radius for grid items */\n  flex-direction: column; /* Stack children vertically */\n  justify-content: space-between; /* Distribute space inside the item */\n  transition: all 0.3s ease; /* Smooth transition for hover effects */\n}\n\n.grid-content-item img {\n\tmax-width: 100%;\n\theight: auto;\n}\n\n.grid-item {\n  background: linear-gradient(145deg, #f5f5f5, #ffffff); /* Subtle gradient for a more dynamic look */\n  padding: 10px; /* Increased padding for more space inside grid items */\n  border-radius: 10px; /* Larger border radius for grid items */\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); /* Softer shadow for a subtle depth effect */\n  display: flex; /* Flex display to better manage the content inside */\n  flex-direction: column; /* Stack children vertically */\n  justify-content: space-between; /* Distribute space inside the item */\n  transition: all 0.3s ease; /* Smooth transition for hover effects */\n}\n\n.grid-item:hover {\n  transform: translateY(-5px); /* Slight lift effect on hover */\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1); /* Increased shadow on hover for a popping effect */\n}\n\n\n.grid-item p {\n    color: #000000;\n    font-size: 15px;\n      \n    font-weight: 300;\n}\n\n\n.inner-grid-item {\n  grid-template-rows: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.inner-grid-item > div:nth-child(1) {\n  height: 70px;\n}\n\n.inner-grid-item > div:nth-child(2) {\n  height: 65px;\n}\n\n.inner-grid-item > div:nth-child(3) {\n}\n\n\n\n\n.action {\n    background: rgba(0, 40, 255, 1); \n    color: white;\n    border: none;\n    padding: 12px 25px; \n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 18px;\n    margin: 5px 6px;\n    cursor: pointer;\n    border-radius: 15px; \n    backdrop-filter: blur(10px); \n    border: 1px solid rgba(255, 255, 255, 0.5); \n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    transition: all 0.3s ease; \n    position: relative; \n    overflow: hidden;\n}\n\n\n\n.action::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.4), transparent); /* Light shine effect */\n    transition: all 0.6s ease;\n}\n\n.action:hover::before {\n    left: 100%;\n}\n\n\n.action:hover {\n    color: #ffffff;\n    background: rgba(0, 40, 255, 1); \n    border: 1px solid #ffffff; \n}\n\n\n\n\n.small-icon {\n      width: 45px;\n  height: auto;\n    }\n\n\n.counter-container {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    background-color: #f0f0f0;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.counter {\n    text-align: center;\n}\n\n.counter p {\n    color: #333;\n    font-size: 20px;\n    margin-top: 10px;\n}\n\n.counter h1 {\n    font-size: 70px;\n    font-weight: 500;\n    color: #0028ff;\n}\n\n.news-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr); \n  gap: 10px; \n  margin: 60px 40px 80px 40px;\n}\n\n.news-inner-grid {\n  display: grid;\n  grid-template-rows: 280px 80px;\n  gap: 10px; \n  background-color: #ffffff;\n  padding: 8px;\n\tcursor: pointer;\n}\n\n.news-inner-grid > div {\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n.news-inner-grid img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0; \n  left: 0;\n}\n\n.news-inner-grid > div:nth-child(2) {\n  background-color: #ffffff;\n}\n\n\n.news-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100000000;\n}\n\n\n.news-modal-content {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    padding: 20px;\n    margin-left: 30px;\n    margin-right: 30px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    text-align: left;\n    overflow-y: auto;\n\t display: flex;\n    flex-direction: column;\n\theight: 90%;\n\twidth: 70%;\n}\n\n.news-modal-content p {\n  font-size: 20px;\n}\n\n.news-modal-content h2 {\n  font-size: 22px;\n\tfont-weight: 500;\n}\n\n.news-modal-content-img {\n  position: relative;\n  text-align: left;\n  height: 350px;\n  width: 100%;\n\tmargin-bottom: 25px;\n}\n\n.news-modal-content-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.modal-title {\n  position: absolute;\n  bottom: 10px; \n  left: 10px; \n\tright: 10px;\n  color: white; \n  padding: 5px;\n\tfont-size: 65px;\n}\n\n.screen-container {\n    position: relative;\n    width: 100%; \n    height: 0; \n    padding-top: 70%;\n}\n\n.screenshot, .screen-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.screenshot img, .screen-image {\n    object-fit: cover; \n}\n\n.screen-image {\n    z-index: 2; \n}\n\n.screenshot {\n    z-index: 1; \n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.screenshot img {\n      width: 90%;\n    margin-top: -22%;\n}\n\n@media only screen and (min-width: 767px) {\n\n\n.pricing-container {\n  display: grid;\n  grid-template-columns: auto 130px 130px 150px 130px;\n  gap: 10px;\n  background-color: #ffffff;\n  padding: 8px;\n  cursor: pointer;\n}\n\n}\n\n\n@media only screen and (max-width: 766px) {\n\n\n.pricing-container {\n  \n  gap: 10px;\n  background-color: #ffffff;\n  padding: 8px;\n  cursor: pointer;\n}\n\n}\n\n.features-list {\n  display: grid;\n  grid-template-rows: repeat(21, 1fr);\n  gap: 10px; \n  background-color: #ffffff;\n\tcursor: pointer;\n}\n\n\n.features-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 10px;\n}\n\n.feature {\n\t  display: grid;\n  grid-template-rows: repeat(21, 1fr);\n\tgap: 10px;\n    padding: 5px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #ffffff;\n    transition: transform 0.3s ease;\n}\n\n.feature:hover {\n    transform: scale(1.05);\n    \t border: 1px solid #0028ff;\n}\n\n\n.feature h1 {\n font-size: 22px;\n      \n    font-weight: 500;\n\tmargin-top: 5px;\n\tmargin-bottom: 10px;\n\ttext-align: center;\n}\n\n\n.feature h2 {\n font-size: 18px;\n      \n    font-weight: 300;\n\tmargin-top: 5px;\n\tmargin-bottom: 10px;\n}\n\n.feature-checkmark, .feature-features {\n  display: flex;\n  align-items: center; \n  justify-content: start; \n  padding-left: 8px;\n\tpadding-right: 8px;\n}\n\n\n.feature-checkmark span {\n\twidth: 100%;\n  text-align: center;\n\tfont-size: 20px;\n\t  \n\tfont-weight: 500;\n}\n\n\n.feature-features span {\n\twidth: 100%;\n  text-align: left;\n\tfont-size: 15px;\n\t  \n\tfont-weight: 300;\n}\n\n\n.feature-checkmark.even-row, .feature-features.even-row {\n  background-color: #F5F5F5; \n}\n\n.feature-checkmark.odd-row, .feature-features.odd-row {\n  background-color: #ffffff; \n}\n\n.highlighted {\n  background-color: #ffffff; \n\t\tborder: 1px #0028FF solid;\n\n}\n\n.bestseller-tag {\n  display: inline-block;\n  background-image: linear-gradient(135deg, #f6d365 0%, #fda085 100%);\n  color: #ffffff; \n  padding: 8px 15px; \n  border-radius: 20px; \n  margin-top: 3px; \n  margin-bottom: 3px; \n  text-align: center;\n  font-weight: bold; \n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n  text-transform: uppercase;\n  letter-spacing: 1px; \n  font-size: 15px; \n  transition: all 0.3s ease; \n}\n\n.bestseller-tag:hover {\n  background-image: linear-gradient(to right, #fda085 0%, #f6d365 100%);\n  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.25); /* More pronounced shadow on hover */\n  transform: translateY(-2px); /* Slight lift effect */\n}\n\n\n\n\n\n\n\n.cookie-consent-modal h2 {\n  margin-top: 0;\n}\n\n.cookie-consent-modal .actions {\n  margin-top: 20px;\n}\n\n.cookie-consent-modal button {\n  padding: 10px 20px;\n  margin: 0 10px;\n  border: none;\n  background-color: #0028FF;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n\t    border: 1px solid #0028ff;\n\tfont-size: 15px;\n\n}\n\n.cookie-consent-modal button:hover {\n  background: #ffffff;\n\t      border: 1px solid #0028ff;\n\tcolor: #0028ff;\n\n}\n\n\n.cookie-consent-modal button.manage-consent {\n  padding: 10px 20px;\n  margin: 0 10px;\n  border: none;\n  background-color: #0028FF;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n\t    border: 1px solid #0028ff;\n\tfont-size: 15px;\n\topacity: 0.5\n\n}\n\n.cookie-consent-modal button:hover.manage-consent {\n  background: #ffffff;\n\t      border: 1px solid #0028ff;\n\tcolor: #0028ff;\n\n}\n\n\n\n\n\n\n\n\n\n\n\n.main-container {\n  display: flex;\n  flex-direction: column;\n\tpadding-top: 80px;\n  min-height: 100vh;\n}\n\n\n.content-homepage {\n  flex-grow: 1;\n  margin: 30px;\n  background-color: #ffffff;\n  scroll-behavior: auto;\n}\n\n\n\n\n\n\n\n\n@keyframes glowing {\n    0% { background-position: 0 0; }\n    50% { background-position: 400% 0; }\n    100% { background-position: 0 0; }\n}\n\n\n\n\n.right-nav-bar-homepage {\n  position: fixed;\n\t grid-column: 3;\n\tz-index: 999;\n\tright: 30px;\n\ttop: 14px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n    justify-content: right;\n    gap: 5px;\n}\n\n\n.right-nav-bar-homepage button {\n\tfont-size: 15px;\n  margin: 0px 0px 0px 0px;\n  padding: 10px 15px 10px 15px;\n  color: #ffffff;\n  text-decoration: none;\n  position: relative;\n  z-index: 0;\n  transition: all 0.5s ease-in-out;\n  background: #000000;\n\tcursor: pointer;\n\t  \n\tfont-weight: 500;\n\twidth: 100%;\n\tborder: 1px #000000 solid;\n\ttext-align: left;\n\t display: inline;\n\tborder-radius: 25px;\n\t\t   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.4);\n\n}\n\n.right-nav-bar-homepage button:hover {\n\topacity: 0.5;\n\t\t\t   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.9);\n\t}\n\n\n.right-nav-bar-homepage .active {\n\t\n  color: #000000;\n    background: #ffffff;\n\t}\n\n.right-nav-bar-homepage select {\n\t\n margin-right: 0px;\n\t}\n\n\n.buy-button, .test-button {\n  margin-top: 5px;\n\tmargin-bottom: 5px;\n  padding: 8px 26px;\n   cursor: pointer;\n  font-weight: bold;\n   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);\n\tborder: 1px #000000 solid;\n}\n\n.buy-button {\n  background-color: #000000;\n  color: white;\n}\n\n.test-button {\n  background-color: #000000;\n  color: white;\n}\n\n.buy-button:hover, .test-button:hover {\n  background-color: #ffffff;\n\tcolor: #000000;\n}\n\n\n\n.toggle-button {\n  padding: 10px 15px;\n\tmargin-bottom: 25px;\n  color: #ffffff;\n\tbackground-color: #000000;\n  cursor: pointer;\n  font-size: 20px;\n\tborder: 1px solid #000000;\n\ttransition: background-color 0.5s, color 0.5s;\n\t   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);\n\n}\n\n\n.toggle-button:hover {\n   background-color: #ffffff;\n  color: #000000;\n }\n\n\ntable .checkmark {\n  color: #000000;\n}\n\ntd.empty {\n\tborder: 0px solid #ddd;\n\tbackground-color: #ffffff;\n}\n\nth.empty {\n\tborder: 0px solid #ddd;\n\tbackground-color: #ffffff;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.headerbar li {\n  position: relative;\n  display: inline;\n  color: #ffffff;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 28px;\n}\n\n.headerbar p {\n  position: relative;\n  display: inline;\n  color: #ffffff;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 28px;\n  font-size: 14px;\n}\n\n\n.headerbar li a {\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.headerbar li a:hover {\n  color: #ffffff;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.headerbar a {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.headerbar a:hover {\n  text-decoration: underline;\n}\n\n\n\n\n\n\n\n.bottombar li {\n  position: relative;\n  display: inline;\n  color: #000000;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 30px;\n}\n\n.bottombar li a {\n  color: #000000;\n  font-size: 14px;\n}\n\n.bottombar li a:hover {\n  color: #000000;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.bottombar a {\n  color: #000000;\n  text-decoration: none;\n}\n\n.bottombar a:hover {\n  text-decoration: underline;\n}\n\n\n.presslist th {\ntext-align: left;\n\tvertical-align: bottom;\n}\n\n.presslist td {\nmin-width: 20px;\n\tvertical-align: bottom;\n}\n\n #chat-history {\n            flex: 2;\n             padding: 3px 5px;\n  font-size: 20px;\n  border: solid 1px;\n  border-color: #000000;\n  margin-top: 10px;\n\t bottom: 50px;\n\t max-height: 450px;\n          overflow-y: scroll;\n\t\n\toverflow-anchor: none;\n        }\n\n\nselect, textarea, input {\n  width: calc(100% - 5px);\n  padding: 8px;\n\tmargin: 5px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-sizing: border-box;\n  font-size: 14px;\n\t}\n\nselect:focus, select:hover, textarea:focus, textarea:hover, input:focus, input:hover {\n  outline: none;\n  border-color: #0028FF;\n}\n\n\n\n\n.language-switcher select {\n  width: 100%;\n\tfont-size: 14px;\n  padding: 5px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-sizing: border-box;\n\tmargin: 0px;\n}\n\n\n\nul {\n  display: block;\n  list-style-type: disc;\n  margin: 0;\n  padding-inline-start: 0;\n}\n\n\n\n\n\n.login-landingpage-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\t\tmargin-bottom: 50px;\n}\n\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n}\n\n.login-form {\n  width: 500px;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #0028FF;\n}\n\n.login-form a {\n    border: 1px solid #fff;\n  border-radius: 10px;\n\tcolor: #0028FF;\n\tpadding: 3px 8px 3px 8px;\n}\n\n.login-form a:hover {\n    border: 1px solid #0028FF;\n}\n\n.login-form .error-message {\n    color: #0028FF;\n}\n\n.login-form .success-message {\n    color: #0028FF;\n}\n\n\n.login-form h1 {\n font-size: 20px;\n\tcolor: #0028FF;\n}\n\n.login-form label {\n  color: #000000;\n}\n\n.login-form input {\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n\n.login-form button {\n    background-color: #0028ff;\n    color: #fff;\n    padding: 10px 20px;\n    border-radius: 20px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s;\n\tmargin-bottom: 10px;\n\tvertical-align: middle;\n\t  border: 1px solid #0028ff;\n}\n\n.login-form button:hover {\nbackground-color: #ffffff;\n\tcolor: #0028ff;\n\t\t  border: 1px solid #0028ff;\n\n}\n\n\n.additional-options button {\n    background-color: #ffffff;\n    color: #0028ff;\n    padding: 5px 10px;\n    border-radius: 8px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s;\n\tvertical-align: middle;\n\tborder: 1px solid #ffffff;\n\tmargin: 12px 3px 0px 3px;\n\n}\n\n.additional-options button:hover {\nbackground-color: #ffffff;\n\tcolor: #0028ff;\nborder: 1px solid #0028ff;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .login-form {\n    width: 90%;\n  }\n}\n\n\n.product-features-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  padding: 2rem;\n  background-color: #f8f9fa; /* Light grey background */\n}\n\n.feature-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.feature-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 15px rgba(0,0,0,0.2);\n}\n\n.feature-item img {\n  width: 100%;\n  height: auto;\n  object-fit: cover; /* Ensures the image covers the area nicely */\n}\n\n.feature-item p {\n  padding: 1rem;\n  font-size: 1rem;\n  color: #333; /* Dark grey text for readability */\n  text-align: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .product-features-container {\n    grid-template-columns: 1fr; /* Stack items in a single column on smaller screens */\n  }\n}\n\n\n\n  .close-button {\n    float: right;\n    border: none;\n    background: none;\n    font-size: 30px;\n\tmax-width: 25px;\n\tborder-radius: 10px;\n\tpadding: 5px;\n}\n\n.close-button:hover {\n    background-color: #000000;\n\tcolor: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
